import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getPrecedingCategoryCatalog = state => state.models[name].data;
export const getCurPrecedingCategory = state => state.models[name].item;